import { FC, useState } from 'react';

import { FormControl, FormField, FormItem } from '@/components/ui/Form';
import { Input } from '@/components/ui/Input';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const BUILDING_NUMBER_NAME = 'building_number';

interface Props {
  name?: string;
}

const InputBuildingNumber: FC<Props> = ({ name = BUILDING_NUMBER_NAME }) => {
  const { i18n } = useLingui();
  const { control, trigger } = useFormContext();
  const [focused, setFocused] = useState(false);

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        validate: (v) => (!v?.trim() ? i18n.t('Uzupełnij nr budynku') : true),
      }}
      render={({
        field: { onBlur, onChange, ...field },
        fieldState: { error },
      }) => (
        <FormItem>
          <FormControl>
            <Input
              label={i18n.t('Nr budynku')}
              error={error?.message}
              success={!focused && !error && !!field.value}
              autoComplete="address-line2"
              onFocus={() => setFocused(true)}
              onBlur={() => {
                setFocused(false);
                onBlur();
              }}
              onChange={(e) => {
                onChange(e);
                if (error) trigger(name);
              }}
              {...field}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};

export default InputBuildingNumber;
